export const styles = {
  createdAtCell: {
    pl: '40px',
  },
};
